package frontend.pages

import androidx.compose.runtime.*
import components.TForm
import components.TTextInput
import frontend.components.Modal
import frontend.components.TWSubmitButton
import frontend.lib.LocalString
import frontend.lib.classList
import kotlinx.coroutines.launch
import net.sergeych.ugdx.PasswordErrorResult
import net.sergeych.ugdx.ServiceState
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun PasswordRequestUI(state: ServiceState.PasswordRequest) {
    val scope = rememberCoroutineScope()
    var password: String? by mutableStateOf(null)
    var isLoading: Boolean by mutableStateOf(false)
    var error: String? by mutableStateOf(null)

    suspend fun authorize(password: String?) {
        isLoading = true

        error = when {
            password == null || password == "" -> LocalString.PasswordEmpty.t
            else -> {
                try {
                    val result: PasswordErrorResult? = state.tryPassword(password)
                    if (result == null) null
                    else result.message
                } catch (err: Exception) {
                    err.toString()
                }
            }
        }

        isLoading = false
    }

    Modal(showX = false) {
        TForm {
            H3(attrs = { classList("text-lg leading-6 font-medium text-gray-900") }) {
                Text("This operation requires password authorization")
            }

            TTextInput("password", password ?: "") {
                onInput { password = it }
                password()
                label { Text("Password") }
            }

            if (error != null)
                P(attrs = { classes("text-red-600") }) { Text(error ?: "") }

            TWSubmitButton("Authorize", isLoading = isLoading) {
                scope.launch { authorize(password) }
            }
        }
    }
}